module.exports = __webpack_public_path__ + "static/media/junior.6.671b6b00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rooms/junior-suite/images/junior.6.jpg
// module id = 660
// module chunks = 0